import React from "react";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export const GroupMasterActiveData = createSlice({
  name: "GroupMasterActiveData",
  initialState: {
    data: {},
  },
  reducers: {
    addGroupDataData: (state, action?: any) => {
      state.data = action.payload;
    },
    clearGroupDataData: (state) => {
      state.data = {};
    },
  },
});
export default GroupMasterActiveData.reducer;
export const { addGroupDataData, clearGroupDataData } =
  GroupMasterActiveData.actions;
